import styled from 'styled-components';
import device from '../../mediaQueries';

interface ChangeShippingWrapperProps {
  onClick: () => void;
}

const ChangeShippingWrapper = styled.div<ChangeShippingWrapperProps>`
  display: flex;
  flex-direction: column;
  flex: 1;
  ${device.desktop`
		margin: 5px;
    border: solid 1px #000;
    width: 217px;
	`}
`;

export default ChangeShippingWrapper;
